import React, { ReactNode } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  link: {
    color: '#fff',
    '&:not(:first-child)': {
      marginLeft: '20px',
    },
  },
  active: {
    color: theme.palette.secondary.main,
  },
}));

type NavigationLinkProps = {
  to: string;
} & { children: ReactNode };

export const NavigationLink: React.FC<NavigationLinkProps> = ({ to, children }) => {
  const classes = useStyles();
  const location = useLocation();

  let className = classes.link;
  if (location.pathname === to) {
    className += ` ${classes.active}`;
  }
  return (
    <Link className={className} underline="none" component={RouterLink} to={to}>
      {children}
    </Link>
  );
};
